var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIconPinWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    fill: "#fdfbe6",
    stroke: "#f4c000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5397 30.351C19.57 30.3685 19.5937 30.3821 19.6105 30.3915L19.6384 30.4071C19.8613 30.5294 20.1378 30.5285 20.3608 30.4075L20.3895 30.3915C20.4063 30.3821 20.43 30.3685 20.4603 30.351C20.5207 30.316 20.607 30.265 20.7155 30.1982C20.9325 30.0646 21.2388 29.8676 21.6046 29.6091C22.3351 29.0931 23.3097 28.3274 24.2865 27.3273C26.2307 25.3368 28.25 22.3462 28.25 18.5C28.25 13.9437 24.5563 10.25 20 10.25C15.4437 10.25 11.75 13.9437 11.75 18.5C11.75 22.3462 13.7693 25.3368 15.7135 27.3273C16.6903 28.3274 17.6649 29.0931 18.3954 29.6091C18.7612 29.8676 19.0675 30.0646 19.2845 30.1982C19.393 30.265 19.4793 30.316 19.5397 30.351ZM20 21.5C21.6569 21.5 23 20.1569 23 18.5C23 16.8431 21.6569 15.5 20 15.5C18.3431 15.5 17 16.8431 17 18.5C17 20.1569 18.3431 21.5 20 21.5Z",
    fill: "#F4C000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconPinWarning);
export default __webpack_public_path__ + "static/media/MapIconPinWarning.1d68b4a62b7a98978ad88450a8d3d592.svg";
export { ForwardRef as ReactComponent };